export const ALREADY_SHOWN_SESSION_STORAGE_KEY = 'financingProductHelperAlreadyShown'
